import React from "react";

type Props = {
  children: React.ReactNode;
  bold?: boolean;
};
const BodyText: React.FC<Props> = (props) => {
  return (
    <div className={`font-comic normal-case ${props.bold && "font-bold"}`}>
      {props.children}
    </div>
  );
};

export default BodyText;
